export default __webpack_public_path__ + "static/media/question.1d210c29.png";